import { useUserRolesStore } from '@fsd/entities/user-roles';

export const setUserRoles = ({ userRoles }) => {
  const userRolesStore = useUserRolesStore();
  userRolesStore.userRoles = userRoles;
};
